export enum OnlineStatus {
	offline = 'offline',
	online = 'online',
	away = 'away',
}
